function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Caminho_7426",
  "data-name": "Caminho 7426",
  d: "M0,0H22V22H0Z",
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Caminho_7427",
  "data-name": "Caminho 7427",
  d: "M3.917,17H7.583a.917.917,0,1,0,0-1.833H3.917a.917.917,0,1,0,0,1.833ZM3,6.917a.919.919,0,0,0,.917.917H18.583a.917.917,0,0,0,0-1.833H3.917A.919.919,0,0,0,3,6.917Zm.917,5.5h9.167a.917.917,0,0,0,0-1.833H3.917a.917.917,0,1,0,0,1.833Z",
  transform: "translate(-0.25 -0.5)",
  fill: "#343a40"
});

var SvgSortIcon = function SvgSortIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sort-icon",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSortIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sort-icon.fc522b06.svg";
export { ForwardRef as ReactComponent };